module.exports = __webpack_public_path__ + "img/active.b12ae26a.gif";